// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ChangePasswordRequestModel from '../../model/change-password-request-model';
import ChangePasswordRequestDTO from '../dto/change-password-request-dto';
import dtoSchema from '../schemas/change-password-request-schema';

export default abstract class ChangePasswordRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ChangePasswordRequestDTO>) {
    super();
    if (data) {
      this.token = data.token;
      this.newPassword = data.newPassword;
    }
  }
  /**
  * @minimum 1
  */
  token?: string;
  /**
  * @minimum 1
  */
  newPassword?: string;

  static toModel(dto: DeepPartial<ChangePasswordRequestDTO>): ChangePasswordRequestModel;
  static toModel(dto: DeepPartial<ChangePasswordRequestDTO> | undefined | null): ChangePasswordRequestModel | undefined;
  static toModel(dto: DeepPartial<ChangePasswordRequestDTO> | undefined | null): ChangePasswordRequestModel | undefined {
    return dto ? new ChangePasswordRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ChangePasswordRequestModel> | ChangePasswordRequestModel): ChangePasswordRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      token: unwrapped.token,
      newPassword: unwrapped.newPassword,
    } as ChangePasswordRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ChangePasswordRequestModel, can not map to ChangePasswordRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
